import { render } from "./ContactUsButton.vue?vue&type=template&id=ca66df7c&scoped=true"
import script from "./ContactUsButton.vue?vue&type=script&lang=js"
export * from "./ContactUsButton.vue?vue&type=script&lang=js"

import "./ContactUsButton.vue?vue&type=style&index=0&id=ca66df7c&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca66df7c"]])

export default __exports__